import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useContent } from '../context/ContentContext';
import Header from './Header';
import Footer from './Footer';
import NewsSection from './NewsSection';
import Modal from './Modal';
import { getMenuConfig } from '../lib/menuConfig';

const NewsPage = () => {
  const { isDark } = useTheme();
  const { siteContent } = useContent();
  const menuConfig = getMenuConfig(siteContent?.global?.menu);

  if (menuConfig.news?.enabled === false) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className={`App min-h-screen ${isDark ? 'bg-[#0A0A0A]' : 'bg-[#F5F0E8]'} text-foreground transition-colors duration-300`}>
      <Header />
      <main>
        {/* Spacer for fixed header */}
        <div className="pt-28 sm:pt-32" />
        <NewsSection />
      </main>
      <Footer />
      <Modal />
    </div>
  );
};

export default NewsPage;
